import { Controller } from '@hotwired/stimulus';
import { fetchTurboStream } from '../helpers/turbo_helper';

export default class TurboStreamLoaderController extends Controller {
  static values = {
    url: String,
    loaded: Boolean
  };

  connect() {
    if (this.loadedValue) {
      return;
    }

    this.loadedValue = true;
    this.load();
  }

  async load() {
    const response = await fetchTurboStream(this.urlValue);

    if (response.status === 429) {
      setTimeout(() => {
        this.load();
      }, 3000);
    }
  }
}
